// extracted by mini-css-extract-plugin
export default {"boxSocialMedia":"Redes_boxSocialMedia__9bmHa"};